export const RoleEnum ={
    STANDARD: "STANDARD",
    ADMIN:"ADMIN" ,
    SUPER_ADMIN:"SUPER_ADMIN" 
}